/*
  Offer pop-up gate: opens the Klaviyo forms listed in Theme settings > Offer pop-ups only when
  every rule passes. Rules and setup: snippets/pmx-offer-gate.liquid.
*/
(function () {
  var cfg = window.PMX_OFFER_GATE;
  if (!cfg) return;

  var forms = (cfg.forms || []).map(function (id) { return String(id).trim(); }).filter(Boolean);
  if (!forms.length) return;

  var SEEN_KEY = 'pmx-offer-seen';

  // --- Rules that can be settled straight away ---------------------------------------------

  function pathWithoutMarket() {
    var path = window.location.pathname;
    var root = (cfg.root || '/').replace(/\/$/, '');
    if (root && path.indexOf(root + '/') === 0) path = path.slice(root.length);
    else if (root && path === root) path = '/';
    return path.replace(/\/$/, '') || '/';
  }

  function excluded() {
    if (cfg.template === 'cart') return true;
    var path = pathWithoutMarket();
    return (cfg.exclude || []).some(function (p) {
      p = String(p).trim().replace(/\/$/, '');
      return p && (path === p || path.indexOf(p + '/') === 0);
    });
  }

  function seen(id) {
    try {
      return (sessionStorage.getItem(SEEN_KEY) || '').split(',').indexOf(id) !== -1;
    } catch (e) {
      return false;
    }
  }

  function markSeen(id) {
    try {
      var list = (sessionStorage.getItem(SEEN_KEY) || '').split(',').filter(Boolean);
      list.push(id);
      sessionStorage.setItem(SEEN_KEY, list.join(','));
    } catch (e) {}
  }

  if (cfg.pastBuyer || excluded()) return;
  forms = forms.filter(function (id) { return !seen(id); });
  if (!forms.length) return;

  // --- Known to Klaviyo ---------------------------------------------------------------------

  function cookieIdentified() {
    var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!m) return false;
    try {
      var data = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(data.$exchange_id || data.$email || data.$phone_number);
    } catch (e) {
      return false;
    }
  }

  // Resolves true when Klaviyo already has a profile for this browser. klaviyo.isIdentified() stays
  // pending until the cookie choice, then answers in ~100ms (checked 22 Oct 2026). Klaviyo's current
  // __kla_id cookie holds only an anonymous {cid}; the cookie check only catches older-format cookies.
  function knownToKlaviyo() {
    return new Promise(function (resolve) {
      var tries = 0;
      (function check() {
        var k = window.klaviyo;
        if (k && typeof k.isIdentified === 'function') {
          // isIdentified() can stay pending (seen before consent), so give it 3s, then use the cookie
          var settled = false;
          var fallback = setTimeout(function () {
            settled = true;
            resolve(cookieIdentified());
          }, 3000);
          Promise.resolve(k.isIdentified())
            .then(function (v) {
              if (settled) return;
              clearTimeout(fallback);
              resolve(!!v || cookieIdentified());
            })
            .catch(function () {
              if (settled) return;
              clearTimeout(fallback);
              resolve(cookieIdentified());
            });
          return;
        }
        // Klaviyo's onsite script loads late; fall back to its cookie after ~10s
        if (++tries > 40) return resolve(cookieIdentified());
        setTimeout(check, 250);
      })();
    });
  }

  // --- Cookie choice --------------------------------------------------------------------------

  function bannerShowing() {
    var host = document.querySelector('csm-cookie-consent');
    var root = host && host.shadowRoot;
    var dialog = root && root.querySelector('[role="dialog"]');
    if (!dialog) return false;
    var r = dialog.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function choiceMade() {
    var p = window.Shopify && window.Shopify.customerPrivacy;
    return !!(p && typeof p.getTrackingConsent === 'function' && p.getTrackingConsent() !== 'no_interaction');
  }

  // Resolves once the visitor has answered the cookie banner, or no banner has shown after ~4s
  function cookieChoice() {
    return new Promise(function (resolve) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        resolve();
      }
      document.addEventListener('visitorConsentCollected', finish);
      var waited = 0;
      (function check() {
        if (done) return;
        if (choiceMade()) return finish();
        if (waited >= 4000 && !bannerShowing()) return finish();
        waited += 500;
        setTimeout(check, 500);
      })();
    });
  }

  // --- Engagement after the choice --------------------------------------------------------------

  function engaged() {
    return new Promise(function (resolve) {
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        window.removeEventListener('scroll', onScroll);
        clearTimeout(timer);
        resolve();
      }
      function onScroll() {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        if (max > 0 && (window.scrollY / max) * 100 >= cfg.scroll) finish();
      }
      var timer = setTimeout(finish, cfg.delay * 1000);
      window.addEventListener('scroll', onScroll, { passive: true });
    });
  }

  // --- Product page buy box -------------------------------------------------------------------

  // Resolves when none of the main product's price, options, Add to cart or waitlist is on screen
  function buyBoxOffScreen() {
    return new Promise(function (resolve) {
      if (cfg.template !== 'product') return resolve();
      var info = document.querySelector('.xo-product-info-content');
      var parts = info ? info.querySelectorAll('.xo-price, .xo-product-info-content__variant, .xo-product-info-content__buy-form, .pmx-waitlist') : [];
      if (!parts.length || !('IntersectionObserver' in window)) return resolve();
      var visible = new Set();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) visible.add(e.target);
          else visible.delete(e.target);
        });
        if (!visible.size) {
          io.disconnect();
          resolve();
        }
      });
      Array.prototype.forEach.call(parts, function (el) { io.observe(el); });
    });
  }

  // --- Open -----------------------------------------------------------------------------------

  function open() {
    var id = forms[0];
    markSeen(id);
    if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
      window.klaviyo.openForm(id);
    } else {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', id]);
    }
  }

  // Identity is checked after the cookie choice: Klaviyo only sets its cookie once it may
  cookieChoice()
    .then(knownToKlaviyo)
    .then(function (known) {
      if (known) return;
      return engaged()
        .then(buyBoxOffScreen)
        .then(open);
    });
})();
